import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useHistory } from "react-router-dom";

import { Button, Result } from "antd";
import { HistoryOutlined } from "@ant-design/icons";
import { getOrderData, getOrderDataTransaction } from "../../api";

import { formatPrice } from "../../utils/common";
import * as queryString from "query-string";

interface Props {
  handleChangeView: any;
  cancelEmbed: any;
}

const WalletBankTransferPending: React.FC<Props> = ({
  handleChangeView,
  cancelEmbed,
}) => {
  const { pathname, search } = useLocation();
  const { t } = useTranslation(["common", "notification", "wallet"]);
  const history = useHistory();
  const [isEmbed, setIsEmbed] = useState<boolean>(false);
  const [orderLoading, setOrderLoading] = useState<boolean>(false);
  const [orderData, setOrderData] = useState<any>(null);
  const [paymentData, setPaymentData] = useState<any>({
    status: "checking",
    orderId: null,
  });

  useEffect(() => {
    const parseQuery = queryString.parse(search);

    if (parseQuery && parseQuery.embed) {
      setIsEmbed(parseQuery.embed === "true");
    }

    checkOrderData();
  }, [pathname, search]);

  const checkOrderData = async () => {
    const parseQuery = queryString.parse(search);
    let count = 0;
    setOrderLoading(true);

    const orderDataPending = await getOrderData(parseQuery.orderId);
    const orderTransactionData =
      orderDataPending.data.order_transaction_data[0];

    var timer = await setInterval(async () => {
      const orderTransaction = await getOrderDataTransaction(
        orderTransactionData.transaction_id
      );
      const orderDataRes = await getOrderData(parseQuery.orderId);

      count += 1;

      // history.push to payment url
      if (orderDataRes) {
        if (orderDataRes.data.order_status === "order_success") {
          setPaymentData((prev: any) => ({
            ...prev,
            status: "success",
          }));

          setOrderLoading(false);
          clearInterval(timer);
          setOrderData(orderDataRes.data);

          console.log(orderDataRes.data);
          return;
        } else if (
          orderDataRes.data.order_status !== "order_success" &&
          orderDataRes.data.order_status !== "order_pending_payment"
        ) {
          setPaymentData((prev: any) => ({
            ...prev,
            status: "error",
          }));

          setOrderLoading(false);
          clearInterval(timer);
          return;
        }
      }

      if (count > 15) {
        setOrderLoading(false);
        clearInterval(timer);
        return;
      }
    }, 3000);
  };

  // Success
  if (paymentData.status === "success") {
    return (
      <Result
        status="success"
        title="Thanh toán thành công!"
        subTitle={
          <>
            <span>{`Quý khách đã nạp thành công ${formatPrice(
              orderData?.total_price
            )}đ vào tài khoản. Mã giao dịch: `}</span>
            <span>
              <b>{orderData?.order_code}</b>
            </span>
          </>
        }
        extra={[
          !isEmbed ? (
            <Button
              key="back"
              onClick={() => {
                history.push(
                  pathname +
                    "?" +
                    queryString.stringify(
                      { type: "overview" },
                      { skipNull: true, skipEmptyString: true }
                    )
                );
                handleChangeView("overview");
              }}
            >
              Trở lại trang thanh toán
            </Button>
          ) : (
            <Button key="exit" onClick={cancelEmbed}>
              Trở lại trang thanh toán
            </Button>
          ),
        ]}
        style={{ background: "#ffffff", borderRadius: "3px", height: "500px" }}
      />
    );
  }

  // Pending
  return (
    <Result
      icon={<HistoryOutlined style={{ color: "#ef4343" }} />}
      title={t("common:Giao dịch đang được xác nhận")}
      subTitle={t(
        "common:Chúng tôi đã nhận được yêu cầu xác nhận giao dịch của bạn. Vui lòng chờ trong giây lát"
      )}
      extra={[
        !isEmbed ? (
          <Button
            key="back"
            onClick={() => {
              history.push(
                pathname +
                  "?" +
                  queryString.stringify(
                    { type: "overview" },
                    { skipNull: true, skipEmptyString: true }
                  )
              );
              handleChangeView("overview");
            }}
          >
            Trở lại trang thanh toán
          </Button>
        ) : (
          <Button key="exit" onClick={cancelEmbed}>
            {t("common:Huỷ")}
          </Button>
        ),
      ]}
      style={{ background: "#ffffff", borderRadius: "3px", height: "500px" }}
    />
  );
};

export default WalletBankTransferPending;
